"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/CalendarSq.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CalendarSq = function CalendarSq(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 183.67 183.77"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Calendar Icon"), _react2.default.createElement("path", {
    className: "calendar-sq",
    d: "M131.19 129.32h-19.67v20.42h19.68v-20.42zM105 74.87H85.28v20.42H105V74.87zm26.24 27.23h-19.72v20.42h19.68v-20.43zm0-27.23h-19.72v20.42h19.68V74.87zm26.24 0h-19.72v20.42h19.68V74.87zm0 27.23h-19.72v20.42h19.68v-20.43zm-52.48 0H85.28v20.42H105v-20.43zM78.72 74.87H59v20.42h19.72V74.87zm-26.24 27.22H32.8v20.42h19.68v-20.42zm26.24 27.22H59v20.42h19.72v-20.41zm-26.24 0H32.8v20.42h19.68v-20.41zm26.24-27.22H59v20.42h19.72v-20.42zM105 129.32H85.28v20.42H105v-20.42zm45.92-115.7V0h-6.56v13.61h-105V0H32.8v13.61H0v170.16h183.67V13.61h-32.8zM177.11 177H6.56V54.45h170.55V177zm0-129.32H6.56V20.42H32.8v6.81h6.56v-6.81h105v6.81h6.56v-6.81h26.24v27.22z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = CalendarSq;